import AccountTreeIcon from '@mui/icons-material/AccountTree';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Chip,
  Container,
  Grid,
  Typography,
} from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DESIGN_PROJECT_ID } from '../../config/designFixtures';
import { isDesignMode } from '../../config/designMode';
import { WORKFLOW_TEMPLATES } from '../../config/workflowTemplates';

const INBOX_CARD = {
  id: DESIGN_PROJECT_ID,
  name: 'Inbox extract fleet',
  summary:
    'Linear agent fleet: inline mailbox → extract senders → look up publications → write JSON → store.',
  patterns: ['linear', 'agent'],
  packages: { length: 5 },
};

const Templates = () => {
  const navigate = useNavigate();
  const design = isDesignMode();
  const cards = [INBOX_CARD, ...WORKFLOW_TEMPLATES];

  return (
    <Container maxWidth="lg" className="workspace-list-page">
      <Box sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" component="h1">
          A starting point for what’s next.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75, mb: 1.5 }}>
          Start with a proven pattern. Make room for your own ideas.
        </Typography>
        {design && (
          <Button
            size="small"
            sx={{ mb: 2 }}
            onClick={() => navigate('/demo')}
          >
            Watch provision / deprovision
          </Button>
        )}
        {!design && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Template editing is available in the local preview.
          </Typography>
        )}
        <Grid container spacing={2}>
          {cards.map((tpl) => (
            <Grid item xs={12} md={6} key={tpl.id}>
              <Card variant="outlined" sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <CardContent sx={{ flex: 1 }}>
                  <Typography variant="h6" component="h2">
                    {tpl.name}
                  </Typography>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, my: 1 }}>
                    {(tpl.patterns || []).map((p) => (
                      <Chip key={p} size="small" label={p} />
                    ))}
                  </Box>
                  <Typography variant="body2" color="text.secondary">
                    {tpl.summary}
                  </Typography>
                </CardContent>
                <CardActions>
                  <Button
                    size="small"
                    startIcon={<AccountTreeIcon />}
                    disabled={!design}
                    onClick={() => navigate(`/canvas/${tpl.id}`)}
                  >
                    Open workflow
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Container>
  );
};

export default Templates;
